import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "aggregation_sum",
  "use": "aggregation_sum-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 14\" id=\"aggregation_sum\"><path d=\"M12 3V0H0v3l5 4-5 4v3h12v-3h-1.5v1.5h-9v-.78l4.44-3.55L7.4 7 5.94 5.83 1.5 2.28V1.5h9V3H12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol